<template>
  <div class="container">

    <div class="main">
      <div class="img-wrap fl">
        <img src="/static/report/logo_zyw.png">
      </div>
      <div class="title fl">
        <p>移宇在线报表系统</p>
      </div>

      <div class="">
        <div class="icon_out_wrap fr" @click="logout">
          <img src="/static/report/icon_out.png"/>
        </div>
        <p class="fr username">{{username}}</p>
      </div>
    </div>

  </div> <!--container结束-->
</template>

<script>
  // import echarts from 'echarts'
  import auth from '../auth/auth'
  export default {
    data() {
      return {
        username:'xxxxx'
      }
    },
    computed:{
      // getLanguage(){
      //
      // }
    },
    watch:{
      // getLanguage(val){
      //
      // }
    },
    mounted(){
      let username=sessionStorage.getItem('username');
      this.username = username;
    },
    methods: {

      logout() {
        this.$http.post('/api/v2.1/logout', {

        }).then(function (res) {
          if (0==res.data.error) {
            sessionStorage.clear()
            this.$router.push('/login');
          }
        }, function (err) {

        })
      },


    },
  }
</script>

<style scoped>


  p,body,html {
    margin:0;
  }

  .container {
    width:100%;
    height:80px;
    background-color:#0c544f;
  }

  .container .main {
    width: 1200px;
    margin:0 auto;
  }

  .container .main .username {
    font-family:Source Han Sans CN;
    color:#ffffff;
    font-size:18px;
    text-align: right;
    line-height: 80px;
    margin-right: 10px;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .img-wrap {
    /*display: table-cell;*/
    padding-top: 12px;
    /*height: 80px;*/
    /*vertical-align: middle;*/
  }

  .title {
    margin-left:30px;
  }
  .title p {
    font-family:Source Han Sans CN;
    color:#ffffff;
    font-size:32px;
    line-height: 80px;
    letter-spacing: 10px;
  }

  .icon_out_wrap {
    /*height:80px;*/
    padding-top: 28px;
  }


</style>



// WEBPACK FOOTER //
// ReportHeader.vue?155623ee